"use strict";
exports.__esModule = true;
//# sourceMappingURL=document-histories.type.js.map